import Layout from '@/components/Layout';
import HeroImageLg from '@/public/assets/Rupiyo_Hero.png';
import HeroImageSm from '@/public/assets/Rupiyo_Hero.png';
import SwitchToProductionMode from '@/components/SwitchToProdMode';
import classes from './styles.module.scss';
import {
  Box,
  Image,
  Heading,
  Flex,
  Text,
  useMediaQuery,
  toast,
  ButtonGroup,
  Button,
} from '@chakra-ui/react';
import CTA from 'components/UI/CTA';
import ToggleRow from 'components/ToggleRow';
import SKCard from 'components/UI/SKCard';
import { SIKKA_FAQS, SECTION_NAMES } from '@/data/faq';
import { useState, useMemo } from 'react';
import { useRouter } from 'next/router';

export default function HomePage() {
  const [lang, setLang] = useState('en'); //en||hi||mr||gu||id
  const router = useRouter();

  // Group FAQs by section
  const groupedFaqs = useMemo(() => {
    const groups = {};
    SIKKA_FAQS.forEach(faq => {
      const sectionKey = faq.sectionKey;
      if (!groups[sectionKey]) {
        groups[sectionKey] = [];
      }
      groups[sectionKey].push(faq);
    });
    return groups;
  }, []);

  const pageTitle = {
    en: 'Frequently Asked Questions',
    hi: 'अक्सर पूछे जाने वाले प्रश्न',
    mr: 'वारंवार विचारले जाणारे प्रश्न',
    gu: 'વારંવાર પૂછાતા પ્રશ્નો',
    id: 'Pertanyaan yang Sering Diajukan'
  };

  return (
    <Layout>
      <Flex
        flexDir={['column', 'column', 'row']}
        justifyContent={'center'}
        alignItems={'center'}
        pr={[2, 0]}
      // mt={-20}
      // mb={-24}
      >
        <Box pr={6} w={['100%']} display={['block', null, 'none']}>
          <Image
            src={HeroImageSm.src}
            alt="Rupiyo illustration"
            mt={[4, null, 'unset']}
            height={['45vh', '45vh', null, '50vh']}
            mx={'auto'}
          />
        </Box>

        <Flex
          flexDir={'column'}
          maxW={['100%']}
          pr={[0, 0, 0, 0, 8]}
          textAlign={['left']}
          mt={['20px', '50px']}
        >
          <Heading
            mb={['10px', '20px']}
            fontSize={['26px', '36px', '44px', '46px', '52px']}
          >
            The best Way to{' '}
            <Text fontSize={['26px', '36px', '44px', '46px', '52px']}>
              <span className={classes.textBg}>
                <span className={classes.textFg}>earn money instantly</span>
              </span>
            </Text>{' '}
            with India’s newest Earning App
          </Heading>
          <Text
            fontSize={['16px', '16px', '18px', '20px']}
            fontWeight={['400']}
            lineHeight={[6, null, 8]}
            mb={'30px'}
            opacity={0.6}
            color={'#9D88B2'}
          >
            Earning money is never easy, it takes hard work and passion but how
            about we make it easy for you? Presenting you the newest application
            where you can earn money instantly.
          </Text>
          <Flex justifyContent={['center', 'flex-start']} px={[4, 0]}>
            <CTA />
          </Flex>
        </Flex>

        <Box display={['none', null, 'block']}>
          <Image
            src={HeroImageLg.src}
            alt="Rupiyo illustration"
            width={['25vw']}
            maxWidth={['550px']}
          />
        </Box>
      </Flex>
      <Flex
        direction={'column'}
        gap={6}
        alignItems={['flex-start', null, 'center']}
        mt={['3rem']}
      >
        <Heading fontSize={'1.5rem'}>{pageTitle[lang]}</Heading>
        <div style={{ margin: '1rem 0rem' }}>
          <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
            <Button
              bg={lang === 'en' ? '#8056B2' : 'gray.300'}
              color={lang === 'en' ? 'white' : 'gray.700'}
              _hover={{ bg: lang === 'en' ? '#6d4a96' : 'gray.400' }}
              onClick={() => setLang('en')}
            >
              English
            </Button>
            <Button
              bg={lang === 'hi' ? '#8056B2' : 'gray.300'}
              color={lang === 'hi' ? 'white' : 'gray.700'}
              _hover={{ bg: lang === 'hi' ? '#6d4a96' : 'gray.400' }}
              onClick={() => setLang('hi')}
            >
              हिंदी
            </Button>
            <Button
              bg={lang === 'mr' ? '#8056B2' : 'gray.300'}
              color={lang === 'mr' ? 'white' : 'gray.700'}
              _hover={{ bg: lang === 'mr' ? '#6d4a96' : 'gray.400' }}
              onClick={() => setLang('mr')}
            >
              मराठी
            </Button>
            <Button
              bg={lang === 'gu' ? '#8056B2' : 'gray.300'}
              color={lang === 'gu' ? 'white' : 'gray.700'}
              _hover={{ bg: lang === 'gu' ? '#6d4a96' : 'gray.400' }}
              onClick={() => setLang('gu')}
            >
              ગુજરાતી
            </Button>
            <Button
              bg={lang === 'id' ? '#8056B2' : 'gray.300'}
              color={lang === 'id' ? 'white' : 'gray.700'}
              _hover={{ bg: lang === 'id' ? '#6d4a96' : 'gray.400' }}
              onClick={() => setLang('id')}
            >
              Indonesia
            </Button>
          </ButtonGroup>
        </div>
        <div className={classes.FaqList}>
          {Object.keys(groupedFaqs).map(sectionKey => (
            <div key={sectionKey}>
              <h2 className={classes.sectionTitle}>
                {SECTION_NAMES[sectionKey][lang]}
              </h2>
              {groupedFaqs[sectionKey].map(faq => (
                <SKCard className={classes.card} id={`${faq.key}`} key={faq.key}>
                  <ToggleRow
                    key={faq.key}
                    header={<div className={classes.rowHeader}>{faq[lang].title}</div>}
                    body={<div>{faq[lang].desc}</div>}
                    defaultOpen={`#${faq.key}` === `#${router.asPath.split('#')[1]}`}
                  />
                </SKCard>
              ))}
            </div>
          ))}
        </div>
      </Flex>
      <SwitchToProductionMode />
    </Layout>
  );
}
